import React from 'react'
import { createGlobalStyle } from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CommonButton = ({
  className = '',
  text,
  width,
  height,
  backgroundColor,
  fontSize,
  color,
  onClick,
  link,
  ...props
}) => {
  const buttonStyle = {
    width,
    height,
    backgroundColor,
    fontSize,
    color,
  }

  const handleClick = e => {
    e.preventDefault()
    onClick()
  }

  return (
    <>
      <ButtonStyle width={width} />
      {link ? (
        <Link
          to={link}
          className={`btn ${className}`}
          style={{ ...props.style, ...buttonStyle }}>
          {text}
        </Link>
      ) : (
        <button
          className={`btn ${className}`}
          style={{ ...props.style, ...buttonStyle }}
          onClick={handleClick}>
          {text}
        </button>
      )}
    </>
  )
}

CommonButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  fontSize: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
  link: PropTypes.string,
}

CommonButton.defaultProps = {
  onClick: undefined,
}

const ButtonStyle = createGlobalStyle`
.btn {
  display: inline-flex;
  outline: none;
  border: 1px solid;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  padding: 1rem;
  justify-content: center;
  align-items: center;
  width: ${({ width }) =>
    width && typeof width === 'number' ? `${width}px` : width};
  font-size: 20px;
  text-decoration: none;
  border-color: #ffa34b;
  background: #ffa34b;
  box-sizing: border-box;

  &:hover {
    background: #ffa34b;
  }
  &:active {
    background: #ffa34b;
  }
}
`

export default CommonButton
